import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Grade from "./components/grade";

import StudentLoginPage from "./components/login/studentLoginPage";
import AdminLoginPage from "./components/adminPages/login";

import Rough from "./components/login/rough";
import StudentApiTest from "./components/login/StudentApiTest";
import TemplateEssayTest from "./components/login/TemplateEssayTest";
import GeneralEndpoints from "./components/login/genralEndpoints";
import EssayGrader from "./components/login/essaygrader";
import AdminTeacher from "./components/adminPages/teacher";
import NewGrade from "./components/NewGrade";

function App() {
  return (
    <>
      <Router>
        <HelmetProvider>
          <Helmet titleTemplate="%s | " defaultTitle="Mains-grader"></Helmet>
        </HelmetProvider>
        <Routes>
          <Route path="/" element={<StudentLoginPage />} />
          <Route path="/rough" element={<Rough />} />
          <Route path="/student-api-test" element={<StudentApiTest />} />
          <Route path="/template-essay-test" element={<TemplateEssayTest />} />
          <Route path="/general-endpoints" element={<GeneralEndpoints />} />
          <Route path="/essay-grader" element={<EssayGrader />} />
          <Route path="/adminLogin" element={<AdminLoginPage />} />
           <Route path="/grade" element={<NewGrade />} />
           <Route path="/admin/teachers" element={<AdminTeacher />} />

        </Routes>
      </Router>
      <ToastContainer
        autoClose={3000}
        progressClassName="toastProgress"
        bodyClassName="toastBody"
      />
    </>
  );
}

export default App;
